/* Sylora (TNS-3052): ruhiges Einblenden beim Scrollen. Nie die erste Section, nie Produkt-Medien (LCP). Respektiert prefers-reduced-motion. */
(function(){
  if(!('IntersectionObserver' in window))return;
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  if(window.Shopify&&Shopify.designMode)return;
  var secs=document.querySelectorAll('main .shopify-section');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
  secs.forEach(function(s,i){
    if(i===0)return;
    if(s.querySelector('.product__media-wrapper,product-info'))return;
    if(s.getBoundingClientRect().top<window.innerHeight)return;
    s.classList.add('sy-reveal');io.observe(s);
  });
})();
